import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { MdKeyboardArrowDown, MdClose, MdAdd, MdDeleteOutline, MdAttachFile } from 'react-icons/md'
import { IoPerson } from 'react-icons/io5'
import styles from './styles.module.scss'
import BreadCrumbs from '../../../assets/BreadCrumbs'

const TABS = ['Общее', 'Индивидуальные']

// --- mock-данные для верстки ---
const lesson = {
  date: '16.11.2025',
  group: '2-127',
  discipline: 'Военно-профессиональная практика (практика в несении внутренней и караульной служб)',
}

const studentsMock = ['Скок Валерий Андреевич', 'Власенко Елизавета Владимировна']
const filesMock = ['Zadanie_SKA_16.11.jpeg', 'Zadanie_SKA_16.11.jpeg', 'Zadanie_SKA_16.11.jpeg', 'Zadanie_SKA_16.11.jpeg']

const SelectArrow = () => <MdKeyboardArrowDown size={24} className={styles.selectArrow} />

const Homework = () => {
  const { pathname } = useLocation()
  const [activeTab, setActiveTab] = useState('Индивидуальные')

  const breadcrumbsData = [
    { label: 'Журнал учета учебных занятий', to: '/journal' },
    { label: lesson.date, to: pathname.replace(/\/homework$/, '') },
    { label: 'Задание на самостоятельную работу' },
  ]

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <BreadCrumbs data={breadcrumbsData} />

        <div className={styles.titleRow}>
          <h1 className={styles.title}>Задание на самостоятельную работу</h1>
          <button type="button" className={styles.outlineButton}>Таблица с заданиями</button>
        </div>

        <div className={styles.tabs}>
          {TABS.map(tab => (
            <button
              key={tab}
              type="button"
              className={`${styles.tab} ${activeTab === tab ? styles.tabActive : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className={styles.meta}>
          <span><span className={styles.metaLabel}>Дата</span> {lesson.date}</span>
          <span><span className={styles.metaLabel}>Группа</span> {lesson.group}</span>
          <span><span className={styles.metaLabel}>Дисциплина</span> {lesson.discipline}</span>
        </div>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Кому выдается задание</h2>
          <label className={`${styles.field} ${styles.fieldWide}`}>
            <span className={styles.fieldLabel}>ФИО студента</span>
            <div className={styles.selectWrap}>
              <select className={styles.select} defaultValue="Не выбрано">
                <option>Не выбрано</option>
              </select>
              <SelectArrow />
            </div>
          </label>

          <button type="button" className={styles.linkButton}>
            <MdAdd size={20} />
            Добавить студента
          </button>

          <div className={styles.students}>
            {studentsMock.map((name, i) => (
              <div key={i} className={styles.studentChip}>
                <span className={styles.studentInfo}>
                  <span className={styles.avatar}><IoPerson size={16} /></span>
                  {name}
                </span>
                <button type="button" className={styles.chipRemove}>
                  <MdClose size={20} />
                </button>
              </div>
            ))}
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Задание</h2>
          <label className={`${styles.field} ${styles.fieldWide}`}>
            <span className={styles.fieldLabel}>Тестирование</span>
            <div className={styles.selectWrap}>
              <select className={styles.select} defaultValue="Нет">
                <option>Нет</option>
                <option>Да</option>
              </select>
              <SelectArrow />
            </div>
          </label>

          <label className={`${styles.field} ${styles.fieldFull}`}>
            <span className={styles.fieldLabel}>Описание задания</span>
            <textarea className={styles.textarea} placeholder="Введите текст" />
          </label>

          <div className={styles.files}>
            {filesMock.map((name, i) => (
              <div key={i} className={styles.fileChip}>
                <span className={styles.fileName}>{name}</span>
                <button type="button" className={styles.fileRemove}>
                  <MdDeleteOutline size={18} />
                </button>
              </div>
            ))}
          </div>

          <button type="button" className={styles.linkButton}>
            <MdAttachFile size={18} />
            Прикрепить файл
          </button>
        </section>

        <div className={styles.actions}>
          <button type="button" className={styles.submitButton}>Отправить задание</button>
        </div>
      </div>
    </div>
  )
}

export default Homework
